import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthorizeAction } from '@mews-commander/modules/src/modules/auth';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey } from '@mews-commander/enums';

function Component() {
    const { authorizationToken } = Route.useParams();
    const { referrer } = Route.useSearch();

    return <AuthorizeAction authorizationToken={authorizationToken} redirectUrl={referrer} />;
}

export const Route = createFileRoute('/_public/Home/AuthorizeAction/$authorizationToken')({
    component: Component,
    staticData: {
        title: TextKey.AuthorizeActionVerificationPendingTitle,
        owner: MewsTeam.Users,
        type: RouteType.Frontend,
    },
    validateSearch: z.object({
        referrer: z.string().optional(),
    }),
});
